export default {
  html: {
    fontSize: [`85%`, `90%`, `95%`, `100%`],
    scrollBehavior: `smooth`
  }
}
